module.exports = __webpack_public_path__ + "img/allikamay_2.f4b4660a.png";